import HomeStartUp from '../pages/HomeStartUp'
import NotFound from '../pages/elements/404'
import TopCpuTable from "../pages/TopCpuTable";
import TopCpuTableLines from "../pages/TopCpuTableLines";
import FlameGraph from "../pages/FlameGraph";

export const routes = [
    {
        path: '/',
        name: 'HomeStartUp',
        component: HomeStartUp
    },
    {
        path: '/gh/:org/:repo/commit/:commit/bench/:bench/cpu/flamegraph',
        name: 'cpu-flamegraph',
        component: FlameGraph,
    },
    {
        path: '/gh/:org/:repo/commit/:commit/bench/:bench/cpu',
        name: 'top-cpu',
        component: TopCpuTable,
        props: { granularity: "functions" },
    },
    {
        path: '/gh/:org/:repo/commit/:commit/bench/:bench/cpu/functions',
        name: 'top-cpu-functions',
        component: TopCpuTable,
        props: { granularity: "functions" },
    },
    {
        path: '/gh/:org/:repo/commit/:commit/bench/:bench/cpu/lines',
        name: 'top-cpu-lines',
        component: TopCpuTableLines,
        props: { granularity: "lines" },
    },
    {
        path: '*',
        name: 'NotFound',
        component: NotFound
    },
];
